import { Pipe, PipeTransform } from '@angular/core';
import { DateUtils } from '@shared/core';

@Pipe({
  name: 'durationPipe',
  standalone: true,
})
export class DurationPipe implements PipeTransform {
  transform(duration?: unknown): string | null {
    if (!duration) return null;

    return DateUtils.durationFormat(duration);
  }
}
